import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const SectionFive = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const cardsData = [
        {
            icon: "assets/images/kwikpricing/ape.png",
            title: "13x ROI with WhatsApp ",
            foundername: "- Bav Samani",
            designation: "CEO, XPLOSIVE APE",
            cta:
                `"Our WhatsApp campaigns hit 80% open rates, far exceeding email or SMS. Kwik Engage is now a core growth driver, delivering strong ROI in months." `,
            width: "400",
            martop: '0'
        }
        // {
        //     icon: "assets/images/kwikpricing/bcf.png",
        //     title: "360° approach. ",
        //     foundername: "- Prabhu Shetty",
        //     designation: "Head of Marketing, Bonkers Corner",
        //     cta:
        //         `"The biggest win with GoKwik is the 360° approach. We no longer juggle 10 tools — now everything we need is in one place.” `,
        //     width: "700",
        //     martop: '10'
        // },
    ];

    return (
        <div className="section-five-testimonal-inter" style={{ padding: isMobile && "60px 0" }}>

            <h1 style={{fontWeight:700}}>Trusted by most innovative D2C brands</h1>
            {
                !isMobile ? (
                    <Swiper
                        centeredSlides={true}
                        grabCursor={true}
                        slidesPerView={1}
                        spaceBetween={30}
                        loop={false}
                        pagination={{ clickable: true }}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        modules={[Pagination, Autoplay]}
                        style={{
                            width: "100%",
                            maxWidth: 1000,
                            minHeight: 360,
                        }}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 2,

                            },
                            768: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            1024: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                        }}
                    >
                        {cardsData.map((card, idx) => (
                            <SwiperSlide key={idx}>
                                <div className="testimonial-content-pricing">
                                    <div>
                                        <img
                                            src={card.icon}
                                            alt={`Logo of ${card.title}`}
                                            className="testimonial-icon-pricing"
                                            loading="lazy"
                                            style={{ width: `${card.width}px`, marginTop: `${card.martop}px` }}

                                        />
                                    </div>
                                    <div className="pricing-testi-content">
                                        <div className="testimonial-headline-pricing">{card.title}</div>
                                        <div className="testimonial-cta-pricing">{card.cta}</div>
                                        <div className="testimonial-founder-pricing">{card.foundername}</div>
                                        <div className="testimonial-designation-pricing">{card.designation}</div>
                                    </div>

                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <div>
                        {cardsData.map((card, idx) => (

                            <div className="testimonial-content-pricin">
                                <div>
                                    <img
                                        src={card.icon}
                                        alt={`Logo of ${card.title}`}
                                        className="testimonial-icon-pricing-mob"
                                        loading="lazy"
                                    // style={{ width: `${card.width}px` }}

                                    />
                                </div>
                                <div className="pricing-testi-content-mob">
                                    <div className="testimonial-headline-pricing-mob">{card.title}</div>
                                    <div className="testimonial-cta-pricing-mob">{card.cta}</div>
                                    <div className="testimonial-founder-pricing-mob">{card.foundername}</div>
                                    <div className="testimonial-designation-pricing-mob">{card.designation}</div>
                                </div>

                            </div>

                        ))}
                    </div>
                )
            }
        </div>
    );
};


export default SectionFive